import get from 'lodash/get';
import * as videoPageActions from '../../action_creators/video/video_page_action_creators';
import log from '../../../services/logger_service';

// import tagAllFeedActions from './async_tag_all_feed_actions';
import jwVideoActions from './async_jw_video_actions';
import jwRelatedVideoActions from './async_jw_related_video_actions';
import jwNewestVideoActions from './async_jw_newest_video_actions';

import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchVideoPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(videoPageActions.videoPageLoading({}, store));
    return Promise.all([
      jwVideoActions(params, store)(dispatch),
      jwRelatedVideoActions(params, store)(dispatch),
      jwNewestVideoActions(params, store)(dispatch),
      // tagAllFeedActions(params, store, true)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(videoPageActions.videoPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }
        dispatch(videoPageActions.videoPageLoadError(err, store));
        return log.error(
          err,
          `Error in tag page actions, message: ${err.message}`
        );
      });
  };
}
